/**
 * Runtime schéma odeslání průvodce cestou (zod) — oddělené od `tripWizard.ts`, aby klientský
 * kód webu (`@ckgo2/shared/client`) dostal definici průvodce bez `zod` (řez 13, F10.5).
 * Čte ho jen server (`schemas/index.ts` → `quizSubmitSchema`); barel jméno nese přes `schemas`.
 */
import { z } from "zod";
import { DURATION_BUCKET_KEYS } from "./tripBuckets";
import { TRIP_TYPES } from "./types";

/** Tělo odeslání průvodce: všechny tři odpovědi povinné, nic dalšího (`.strict()`). */
export const wizardAnswersSchema = z
  .object({
    tripType: z.enum(TRIP_TYPES),
    duration: z.enum(DURATION_BUCKET_KEYS),
    bestMonth: z.number().int().min(1).max(12),
  })
  .strict();
